import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { PhoneInput } from '@atlas/components';
import { SessionStorageManager } from '@atlas/core';

import Field from 'common/Form/Field';
import useTranslate from 'common/I18n/Interpreter';
import { useIsRtl } from 'hooks/useIsRtl';

const DEFAULT_COUNTRY = 'br';

const PhoneField = ({ field, onBlur, onChange, onFocus }) => {
  const { autocomplete, disabled, errors, isModifiable = true, name, placeholder, value } = field;

  const country = SessionStorageManager.getItem('client-country') || DEFAULT_COUNTRY;

  const isRtl = useIsRtl();
  const t = useTranslate();

  const changeHandler = useCallback(
    (value = '') => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <Field className="block" isSignupForm options={field}>
      <PhoneInput
        autocomplete={autocomplete}
        defaultCountry={country.toLowerCase()}
        disabled={disabled || !isModifiable}
        emptySearchText={t('country_not_found')}
        error={!!errors?.length && field.touched}
        inputMode="tel"
        isRtl={isRtl}
        name={name}
        onBlur={onBlur}
        onChange={changeHandler}
        onFocus={onFocus}
        placeholder={placeholder}
        renderCountryName={country => t(`country_${country.iso2}`)}
        searchInputPlaceholder={t('country_search')}
        type="tel"
        value={value || ''}
      />
    </Field>
  );
};

PhoneField.propTypes = {
  field: PropTypes.shape({
    autocomplete: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    errors: PropTypes.arrayOf([PropTypes.string]),
    isModifiable: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    touched: PropTypes.bool.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default PhoneField;
